import React, { useState } from 'react';
import { initiativeService } from '../services/api';
import Spinner from './Spinner';

interface AiCheckResult {
  success: boolean;
  endpoint: string;
  deployment: string;
  api_version: string;
  response?: string;
  error?: string;
}

const AIDebugLog: React.FC = () => {
  const [result, setResult] = useState<AiCheckResult | null>(null);
  const [loading, setLoading] = useState(false);
  const [requestError, setRequestError] = useState<string | null>(null);

  const runCheck = async () => {
    setLoading(true);
    setRequestError(null);
    setResult(null);
    try {
      const res = await initiativeService.runAiCheck();
      setResult(res.data);
    } catch (err: any) {
      setRequestError(err?.response?.data?.detail || err?.message || 'AI check request failed.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
        <h2 style={{ margin: 0 }}>AI Check</h2>
        <button
          onClick={runCheck}
          disabled={loading}
          style={{
            background: '#0b5ed7', color: '#fff', border: 'none', borderRadius: '6px',
            padding: '8px 16px', fontSize: '14px', cursor: loading ? 'default' : 'pointer',
            opacity: loading ? 0.7 : 1,
          }}
        >
          {loading ? 'Checking...' : 'Run AI Check'}
        </button>
      </div>
      <p style={{ color: '#666', fontSize: '13px', marginTop: 0 }}>
        Makes a live test call to Azure OpenAI and reports the result, including the exact endpoint,
        deployment, and API version used.
      </p>

      {loading && <Spinner />}

      {requestError && <div style={{ color: '#c0392b' }}>{requestError}</div>}

      {result && (
        <div
          style={{
            border: `1px solid ${result.success ? '#badbcc' : '#f5c2c7'}`,
            background: result.success ? '#d1e7dd' : '#f8d7da',
            borderRadius: '8px',
            padding: '16px',
            marginTop: '8px',
          }}
        >
          <div style={{ fontWeight: 600, marginBottom: '8px', color: result.success ? '#0f5132' : '#842029' }}>
            {result.success ? '✓ AI call succeeded' : '✗ AI call failed'}
          </div>
          <table style={{ fontSize: '13px', borderCollapse: 'collapse' }}>
            <tbody>
              <tr>
                <td style={{ fontWeight: 600, paddingRight: '12px', verticalAlign: 'top' }}>Endpoint</td>
                <td>{result.endpoint}</td>
              </tr>
              <tr>
                <td style={{ fontWeight: 600, paddingRight: '12px', verticalAlign: 'top' }}>Deployment</td>
                <td>{result.deployment}</td>
              </tr>
              <tr>
                <td style={{ fontWeight: 600, paddingRight: '12px', verticalAlign: 'top' }}>API Version</td>
                <td>{result.api_version}</td>
              </tr>
              {result.success ? (
                <tr>
                  <td style={{ fontWeight: 600, paddingRight: '12px', verticalAlign: 'top' }}>Response</td>
                  <td>{result.response}</td>
                </tr>
              ) : (
                <tr>
                  <td style={{ fontWeight: 600, paddingRight: '12px', verticalAlign: 'top' }}>Error</td>
                  <td style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{result.error}</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AIDebugLog;

